import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { ICreateRequest } from 'interfaces/create-duck';
import { requestErrorHandler } from 'utils';
import { CreateRegionalActions } from 'store/ducks/settings/regional';

export function* createRegionalRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/regional`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateRegionalActions.success(data));
    notify('success', 'Regional cadastrado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(CreateRegionalActions.failure(errorMessage));
  }
}
